import React from 'react';

// AuthProvider is mounted once at the application root. Keeping this wrapper
// preserves the route API without creating competing auth subscriptions.
const FullAuthShell = ({ children }) => children;

export default FullAuthShell;
